// src/components/CTASection.jsx
import React from "react";
import AnimatedLink from "../AnimatedLink"; // adjust path if needed

const ctaContent = {
    headline: ["Reclaim, Restore, and Grow with Gantavyam"],
    subheader: ["Helping you recover lost shares and unlock your true wealth potential."],
    button: ["Get in Touch"],
};

export default function CTASection() {
    return (
        <section
            className="py-20"
            style={{
                backgroundColor: "var(--bg-base)",
                color: "var(--bg-surface)",
            }}
        >
            <div className="max-w-4xl mx-auto text-center px-6">

                {/* Headline */}
                <h2 className="text-5xl md:text-4xl text-[var(--text-primary)] font-semibold leading-snug mb-4">
                    <span style={{ color: "var(--color-primary)" }}>Reclaim</span>,{" "}
                    <span style={{ color: "var(--color-primary)" }}>Restore</span>, and{" "}
                    <span style={{ color: "var(--color-primary)" }}>Grow</span> with{" "}
                    <span className="text-[#e96a1e]">Gantavyam</span>
                </h2>

                {/* Subheader */}
                {ctaContent.subheader[0] && (
                    <p
                        className="text-lg md:text-xl leading-relaxed mt-2"
                        style={{ color: "var(--text-secondary)" }}
                    >
                        {ctaContent.subheader[0]}
                    </p>
                )}

                {/* CTA button */}
                <div className="mt-10">
                    <a
                        href="#contact"
                        className="inline-block px-8 py-3 rounded-md text-lg font-semibold transition-transform hover:no-underline hover:-translate-y-0.5"
                        style={{
                            backgroundColor: "var(--color-primary)",
                            color: "var(--bg-surface)",
                        }}
                    >
                        {ctaContent.button[0]}
                    </a>
                </div>
            </div>
        </section>
    );
}
